import { formatDate } from 'date-fns';
import React from 'react';

interface TimelineDateProps {
  date: string;
  className?: string;
}

export function TimelineDate({
  date,
  className = '',
}: TimelineDateProps): JSX.Element {
  return (
    <span
      className={`text-xs text-gray-500 font-semibold ml-2 mr-4 min-w-[80px] ${className}`}
    >
      {formatDate(date, 'dd MMM yyyy')}
    </span>
  );
}
